import { render, staticRenderFns } from "./GameShowPage.vue?vue&type=template&id=d2d5f86c"
import script from "./GameShowPage.vue?vue&type=script&lang=js"
export * from "./GameShowPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports